import 'regenerator-runtime/runtime';
import { createModule } from 'saga-slice';
import { initialState, UserDataState } from './stateType';
import { UserData } from '../../models/userData';
import { fetchUserDataSagaFactory, submitFeedBack } from './sagas';

const Slice = createModule({
  name: 'userData',
  initialState,
  reducers: {
    fetchUserData: (state: UserDataState) => {
      state.loading = true;
    },
    fetchUserDataSuccess: (state: UserDataState, payload: UserData) => {
      state.loading = false;
      state.error = null;
      state.userData = payload;
    },
    fetchUserDataError: (state: UserDataState, payload: string) => {
      state.loading = false;
      state.error = payload;
    },
    changeSelectedLanguage: (state: UserDataState, payload: string) => {
      state.selectedCountryId = payload;
    },
    submitFeedBack: () => {
      //Do nothing
    },
    feedBackSubmitted: (state: UserDataState) => {
      state.userData.nextFeedbackDate = new Date('3000').toISOString();
    },
  },
  sagas: (actions) => ({
    [actions.fetchUserData]: fetchUserDataSagaFactory(actions),
    [actions.submitFeedBack]: submitFeedBack(actions),
  }),
});

export default Slice;
export const userDataActions = Slice.actions;
